<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <el-dropdown
    v-if="!$device.mobile"
    trigger="click"
    class="international flex"
    @command="$emit('handleSetLanguage', $event)"
    @visible-change="onShow"
  >
    <div class="flex">
      <svg-icon icon-class="icon-crm-earth" class-name="!inline-block !w-24 !h-24 text-text-secondary" />
    </div>
    <el-dropdown-menu ref="dropmenu" slot="dropdown">
      <el-dropdown-item
        v-for="(item, index) in languageList"
        :key="index"
        :disabled="language === item.value"
        :command="item"
        >{{ item.name }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  <div v-else @click="showDrawer = true">
    <svg-icon icon-class="icon-crm-earth" class-name="!inline-block !w-24 !h-24 text-text-secondary" />
    <m-drawer :title="$t('Commons.pleaseChoiceLikeLanguage')" :show.sync="showDrawer" :show-footer="false">
      <div slot="content" class="m-lang-drawer">
        <div
          v-for="(it, index) in languageList"
          :key="index"
          class="m-lang-list"
          :class="{
            'select-lang': language === it.value
          }"
          @click="handleSetLanguage(it)"
        >
          <span>{{ it.name }}</span>
        </div>
      </div>
    </m-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery'
import mDrawer from '../mobile/base/m-drawer.vue'
import { getLanguage } from '@/lang'
export default {
  name: 'LangDropDown',
  components: {
    mDrawer
  },
  data() {
    return {
      showDrawer: false
    }
  },
  computed: {
    ...mapState(['languageList']),
    language() {
      return getLanguage()
    }
  },
  methods: {
    onShow(e) {
      if (!e) return
      if (this.language !== 'ar') return
      setTimeout(() => {
        const offset = $(this.$el).offset()
        if (!this.$device.mobile) {
          $(this.$refs.dropmenu.$el).css({
            top: offset.top + 20 + 'px',
            left: offset.left - 8 + 'px',
            'max-width': '380px',
            right: 'auto'
          })
        } else {
          $(this.$refs.dropmenu.$el).css({
            top: offset.top + 20 + 'px',
            left: offset.left + 'px',
            'max-width': '380px',
            right: 'auto'
          })
        }
      }, 100)
    },
    handleSetLanguage(it) {
      this.showDrawer = false
      this.$emit('handleSetLanguage', it)
    }
  }
}
</script>

<style lang="scss">
.langdropdown {
  position: relative;

  .pos {
    max-width: 382px;
    cursor: pointer;

    em {
      font-size: theme('fontSize.middlePlus');
      color: theme('colors.text.secondary');
      vertical-align: middle;

      &:hover {
        color: color-mix(in srgb, theme('colors.primary') 90%, theme('colors.assist.white') 10%);
      }
    }
  }
}

.international .pos > em {
  font-size: theme('fontSize.smallPlus');
  color: theme('colors.text.third');
}

.international .pos > span {
  margin-left: 8px;
  font-family: theme('fontFamily.pingFang');
  font-size: theme('fontSize.small');
  font-weight: 400;
  color: theme('colors.text.regular');
}

.international .pos > i {
  font-size: theme('fontSize.small');
  color: theme('colors.text.third');
  transform: rotate(90deg) scale(0.8);
}

@include global.response_to(('mobile', 'pad')) {
  .international {
    .pos {
      .lang-label {
        display: none;
      }

      .el-icon-arrow-right {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.m-lang-drawer {
  padding: 24px;

  .m-lang-list {
    width: 100%;
    height: 48px;
    margin-bottom: 12px;
    text-align: center;
    background: theme('colors.bgColor.global');
    border: 1px solid theme('colors.border');
    border-radius: theme('borderRadius.small');

    &.select-lang {
      color: theme('colors.primary');
    }

    > span {
      line-height: 48px;
    }
  }
}
</style>
